import { useLocation, useNavigate } from 'react-router-dom';
import { NavBar } from '@design-system/NavBar';
import { Button } from '@design-system/Button';

export const QuestionnaireDetailsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentQuestionnaire = location.state?.questionnaire;

  if (!currentQuestionnaire) {
    return null;
  }

  return (
    <section className="w-full page-container">
      <NavBar
        returnButtonTitle="Questionnaire Home"
        className="md:-ml-5 mt-8"
        onReturnClick={() => navigate('/questionnaires')}
      />
      <div className="mt-8">
        <div className="mb-8">
          <p className="typography-d2 text-primary mt-8 mb-6">
            {currentQuestionnaire.title}
          </p>
          <p className="typography-body text-secondary mb-6">
            Estimate time to complete: {currentQuestionnaire.timing}
          </p>
          <p className="typography-body text-secondary">
            {currentQuestionnaire.description}
          </p>
        </div>
        <Button
          className="w-full md:w-auto"
          onClick={() =>
            navigate(
              `/questionnaires/${currentQuestionnaire.groupId}/questions`,
              {
                state: { questionnaire: currentQuestionnaire },
              },
            )
          }
        >
          {currentQuestionnaire.progress > 0 ? 'Continue' : 'Get started'}
        </Button>
      </div>
    </section>
  );
};
